<template>
  <Document
    v-for="(pdf, index) in step.files"
    :key="pdf.uri"
    :step="step"
    :pdf="pdf"
    :index="index"
    :has-image="index === 0"
  />
</template>
<script setup>
import Document from "./Document.vue";
const { step } = defineProps({ step: Object });
</script>
